export enum HeadingUnit {
    Degrees = 0,
    Cardinal = 1
}

export enum DistanceUnits {
    Metric = 0,
    Imperial = 1
}